<template>
    <vx-table-row>
        <vx-table-row-item>
            <template v-slot:label> ID: </template>
            <div class="break-all">
                <vx-badge class="mr-2 cursor-pointer" @click.prevent="copyId()" size="xs" color="slate">{{ props.modelValue.id }}</vx-badge>
            </div>

        </vx-table-row-item>

        <vx-table-row-item class="xl:col-span-2!">
            <template v-slot:label> Name: </template>
            <div class="font-bold text-slate-700 break-all xl:py-2">
                {{ props.modelValue.name }}
            </div>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Status: </template>
            <vx-badge class="mr-4" size="xs" :color="CAMPAIGN_STATUSES[props.modelValue.status]?.badge" data-test="campaign-status">
                {{ CAMPAIGN_STATUSES[props.modelValue.status]?.label }}
            </vx-badge>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Audience Type: </template>
            {{ audienceType }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Added at: </template>

            <vx-popover hover
                        :arrow="true"
                        placement="top"
                        :class="createdColor"
                        :key="dateTimeKey">
                {{ fromNow(props.modelValue.created_at) }}
                <template v-slot:content>
                    {{ shortDateTimeTzSpread(props.modelValue.created_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>
    </vx-table-row>
</template>

<script setup>
import {
    VxBadge,
    VxPopover,
    VxTableRow,
    VxTableRowItem,
} from '@voxie/frontend-components';
import { computed } from 'vue';
import { audienceTypeLabel, CAMPAIGN_STATUSES } from '../../../../constants/campaign';
import { useToasted } from '../../../../composables/useToasted';
import { fromNow, getClientTz, shortDateTimeTzSpread } from '../../../../utils/date';
import { useInterval } from '@vueuse/core';
import dayjs from 'dayjs';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

const toasted = useToasted();

const copyId = () => {
    navigator.clipboard.writeText(props.modelValue.id);
    toasted.success(`${props.modelValue.id} copied to clipboard.`)
};

const audienceType = computed(() =>
    audienceTypeLabel(props.modelValue.type)
);

const createdColor = computed(() => {
        return dayjs.utc(props.modelValue.created_at).tz(getClientTz()).isToday() ? 'text-emerald-700' : '';
    },
);

const dateTimeKey = useInterval(60000);

</script>
